import axios from "axios";
import { createContext } from "react";

const SysadminContext = createContext();

export const SysadminContextProvider = ({ children }) => {

  const getApplications = () => {
    return axios.get("/api/sysadmin/applications");
  };
  const getApplication = (applicationId) => {
    return axios.get("/api/sysadmin/applications/" + applicationId);
  };
  const getApplicationByShortCode = (shortCode) => {
    return axios.get("/api/sysadmin/applications/by-short-code/" + shortCode);
  };
  const getApplicationResources = (applicationId) => {
    return axios.get("/api/sysadmin/applications/" + applicationId + "/resources");
  }
  const createApplication = (application) => {
    return axios.post("/api/sysadmin/applications", application);
  }
  const updateApplication = (application) => {
    return axios.put("/api/sysadmin/applications/" + application.id, application);
  }
  return (
    <SysadminContext.Provider
      value={{
        getApplication,
        getApplicationByShortCode,
        getApplications,

        getApplicationResources,
        createApplication,
        updateApplication
      }}
    >
      {children}
    </SysadminContext.Provider>
  );
};

export default SysadminContext;
